import axios from 'axios';

export const petpoojaService = {
  // Get menu from Petpooja using menusharingkey (petPoojaID)
  getPetpoojaMenu: async (menusharingkey) => {
    try {
      console.log('Fetching Petpooja menu for menusharingkey:', menusharingkey);
      const response = await axios.get(`https://fynito.com/petpooja/restaurant`, {
        params: {
          menusharingkey: menusharingkey
        }
      });
      console.log('Petpooja API response:', response.data);
      
      // Extract the details object which contains items and categories
      // The API returns: { success: true, data: { details: { items: [], categories: [] } } }
      if (response.data && response.data.success && response.data.data && response.data.data.details) {
        return response.data.data.details;
      }
      
      // Fallback: return the full response if structure is different
      return response.data;
    } catch (error) {
      console.error('Error fetching Petpooja menu:', error);
      throw error;
    }
  }
};